import { Component, OnDestroy, OnInit } from '@angular/core';
import { AccountConfigurationService } from '../../services/account-configuration.service';
import { AccountConfigurationType } from '../../models/enums/account-configuration-type-enum';
import { ConfigurationProjectVisibility } from '../../models/enums/configuration-project-visibity-enum';
import { AccountContextService } from 'src/app/authentication/services/account-context.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'account-configuration',
  templateUrl: './account-configuration.component.html',
  styleUrls: ['./account-configuration.component.scss']

})

export class AccountConfigurationComponent implements OnInit, OnDestroy {
  showSecondTab = false;
  private destroy$ = new Subject<void>();

  constructor(
    private accountConfigurationService: AccountConfigurationService,
    private accountContext: AccountContextService) { }

  ngOnInit(): void {
    const account = this.accountContext.getSelectedAccountId();

    if (!account) {
      this.showSecondTab = false;
      return;
    }

    this.accountConfigurationService.getAccountConfigurations(account)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: (data) => {
        const projectVisibilityConfiguration = data.ConfigurationItems.find(element => element.Type === AccountConfigurationType.ConfigurationProjectVisibility);
        this.showSecondTab = projectVisibilityConfiguration.Value == ConfigurationProjectVisibility.PublicByGroup;
      }
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

